import { PaywallPaymentModalViewedEventTracking } from '@/modules/auth/models/segmentevents/PaywallPaymentModalViewedEventTracking';

export class PaywallPaymentModalUpgradeScreenSelectedEventTracking extends PaywallPaymentModalViewedEventTracking {}
